module.exports = __webpack_public_path__ + "static/media/add_more.51a0eca1.svg";